export const layoutPadding = 'px-8 lg:px-16 xl:px-24'
export const layoutPaddingMinified = 'px-2 lg:px-16 xl:px-24'
export const inputFocus =
  'focus-within:ring-navy focus-within:ring-2 focus-within:ring-offset-0 focus-within:outline-none transition-shadow duration-200 ease-in-out'
export const inputError =
  'ring-red-400 ring-1 ring-offset-0 outline-red-400 outline-1'
export const inputDisabled = 'disabled:bg-grey-10 disabled:cursor-not-allowed'
export const inputOutlined = 'outline-[0.7px] outline-grey-50'
export const inputBase = 'h-11 w-full rounded hover:bg-grey-5 transition-colors'
export const textareaBase =
  'w-full rounded-md hover:bg-grey-5 transition-colors p-2'
export const textErrorColor = 'text-red-400'
